"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Colors = require("../../constants/Colors");

var _individual = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/individual-1"));

var _templateObject, _templateObject2, _templateObject3;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var StyledLearnerBanner = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "LearnerBanner__StyledLearnerBanner",
  componentId: "sc-1lhjlap-0"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    background-color: ", ";\n    min-height: 100px;\n    display: flex;\n    align-items: center;\n    word-break: break-all;\n"])), _Colors.mercury);

var StyledProfileImage = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "LearnerBanner__StyledProfileImage",
  componentId: "sc-1lhjlap-1"
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    margin: 0px 15px 0px 30px;\n    \n    .default-icon {\n        border: 1px solid ", ";\n        color: ", ";\n        background-color: ", ";\n        height: 60px;\n        width: 60px;\n    }\n\n    .profile-image {\n        max-width: 60px;\n    }\n"])), _Colors.alto, _Colors.alto, _Colors.wildSand);

var StyledLearnerName = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "LearnerBanner__StyledLearnerName",
  componentId: "sc-1lhjlap-2"
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n    color: ", ";\n    font-size: 25px;\n    font-weight: bold;\n"])), _Colors.emperor);

var LearnerBanner = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LearnerBanner, _Component);

  var _super = _createSuper(LearnerBanner);

  function LearnerBanner() {
    (0, _classCallCheck2.default)(this, LearnerBanner);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(LearnerBanner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          profileImageUrl = _this$props.profileImageUrl,
          displayName = _this$props.displayName;
      var iconDiv;

      if (profileImageUrl && profileImageUrl.trim().length > 0) {
        iconDiv = /*#__PURE__*/_react.default.createElement("img", {
          src: this.props.profileImageUrl,
          className: "profile-image"
        });
      } else {
        iconDiv = /*#__PURE__*/_react.default.createElement(_individual.default, {
          className: "default-icon",
          size: 60
        });
      }

      return /*#__PURE__*/_react.default.createElement(StyledLearnerBanner, {
        className: "learner-banner"
      }, /*#__PURE__*/_react.default.createElement(StyledProfileImage, {
        className: "profile-image-container"
      }, iconDiv), /*#__PURE__*/_react.default.createElement(StyledLearnerName, {
        className: "learner-display-name"
      }, displayName));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        profileImageUrl: _propTypes.default.string,
        displayName: _propTypes.default.string
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        displayName: ''
      };
    }
  }]);
  return LearnerBanner;
}(_react.Component);

exports.default = LearnerBanner;